import lessRequire from '../../../../config/less-require-resolver';
import React from 'react';
import PropTypes from 'prop-types';
import Popover from '../../../shared/popover';
import SuggestForm from './suggest-form';

lessRequire('modules/statistics/components/save-export/main.less');

const SaveExport = ({
	isOpen,
	data,
	onToggle,
	onApply,
	onSave,
	onExport,
	intl
}) =>
	<div className="save-tool">
		<Popover head={getPopoverHead(onToggle)} isShow={isOpen} onOutSideClick={e => onToggle()}>
			<div className="save-tool__suggest">
				<SuggestForm
					data={data}
					onApply={onApply}
					onSave={onSave}
					onExport={onExport}
					intl={intl}
					onToggle={onToggle}/>
			</div>
		</Popover>
	</div>;

SaveExport.propTypes = {
	isOpen: PropTypes.bool,
	data: PropTypes.array,
	onToggle: PropTypes.func,
	onApply: PropTypes.func,
	onSave: PropTypes.func,
	onExport: PropTypes.func,
	intl: PropTypes.func
};

export default SaveExport;

const getPopoverHead = onToggle => <div className="save-tool__head" onClick={onToggle} />;



// WEBPACK FOOTER //
// ./frontend/cabinets/modules/statistics/components/save-export/main.js